import React, { useState, useEffect } from 'react'
import { env, pipeline } from '@xenova/transformers'
import fuzzysort from 'fuzzysort'

env.allowLocalModels = false
env.useBrowserCache = true
env.localModelPath = 'https://huggingface.co/Xenova/'
env.verbose = true

const categories = [
  {
    name: 'creator',
    keywords: ['creator', 'author', 'who made', 'who created', 'who built'],
    answers: [
      'Ventrai was built by Denzel Babajide, a developer and content creator.',
      'The creator of Ventrai is Denzel Babajide. You can find more about him at https://growwithdenzel.tech.',
      'Ventrai is a solo project by Denzel Babajide, who also shares tech content online.',
      'Denzel Babajide developed Ventrai and maintains it himself.',
      'Yep, Denzel Babajide made this! He also runs a cool YouTube channel called growwithdenzel.',
    ],
  },
{ name: 'about ventrai', 
  keywords: [ 'what is ventrai', 'explain ventrai', 'ventrai about', 'tell me about ventrai', 'about ventrai', 'why ventrai', 'purpose of ventrai', 'ventrai mission', 'ventrai created for', 'ventrai goal', 'reason for ventrai', 'ventrai aim', "choose ventrai", "pick ventrai" ], 
  answers: [ 'Hey there! 👋 Wondering about Ventrai? Ventrai is a platform created by a 12-year-old with a fantastic mission: connecting people who want to learn with amazing mentors and making learning accessible!', 
            'Hi! Let me tell you about Ventrai! It is a friendly space made by a 12-year-old to help mentors and mentees connect easily and share knowledge.', 
            "Curious about Ventrai? It is a platform designed by a 12-year-old to make it simple for mentors and mentees to find each other and share knowledge, making learning accessible!", 
            'Hello! Ventrai is a cool platform created by a 12-year-old with the goal of making learning from others super accessible for everyone by connecting mentors and mentees.', 
            'Thinking about Ventrai? It is a supportive and easy-to-use space, built by a 12-year-old, to connect mentors with mentees and facilitate learning.', 
            'Want to know about Ventrai? It is a platform made by a 12-year-old to help people learn from each other in a simple and welcoming way by connecting them with mentors!', 
            'Hey! Ventrai is a platform created by a 12-year-old with a clear purpose: to make learning from mentors accessible and easy for anyone by connecting them.', 
            'Hi there! Ventrai is a platform, designed by a 12-year-old, that connects mentors and mentees in a supportive and easy-to-navigate space to facilitate learning.', 
            'Wondering what Ventrai is all about? It is a platform created by a 12-year-old to help mentors and mentees connect effortlessly and make learning accessible!', 
            'Hello! Ventrai is a platform built by a 12-year-old with the simple yet powerful goal of bringing mentors and mentees together to share knowledge easily!', 
            'Ventrai is a platform created by a 12-year-old with the main goal of connecting mentors and mentees easily, aiming to make learning accessible for all.', 
            'The purpose behind Ventrai, created by a 12-year-old, is to bridge the gap between those who want to learn and those who can teach, facilitating knowledge sharing.', 
            'Ventrai was created by a 12-year-old with the mission to simplify the process of finding a mentor or mentee, making educational connections more attainable.', 
            'The reason for Ventrai is creation by a 12-year-old is to establish a user-friendly platform where mentors and mentees can connect and collaborate effortlessly.', 
            'Ventrai, a project by a 12-year-old, aims to provide a dedicated space for mentor-mentee interactions, encouraging a culture of shared learning.', 
            'The core idea behind Ventrai, developed by a 12-year-old, is to offer an intuitive platform that promotes accessible learning through effective mentor-mentee connections.', 
            'Ventrai was built by a 12-year-old with the intent of creating a supportive community where individuals can easily find guidance and share their expertise.', 
            'The mission of Ventrai, a platform by a 12-year-old, is to empower users by providing a straightforward way to connect with mentors and enhance their learning journey.', 
            'Ventrai, created by a 12-year-old, is designed to foster meaningful mentor-mentee relationships, making the pursuit of knowledge more accessible and engaging.', 
            'The primary objective of Ventrai, a platform developed by a 12-year-old, is to facilitate easy connections between mentors and mentees, thereby expanding learning opportunities for everyone.' ]
  },
  {
    name: 'socials',
    keywords: ['youtube', 'facebook', 'instagram', 'social', 'social media', 'channels', 'pages'],
    answers: [
      'Denzel is on YouTube as growwithdenzel and active on other social platforms too.',
      'You can follow Denzel Babajide on Instagram, Facebook, and YouTube under the name growwithdenzel.',
      'Looking for Denzel’s socials? Check out growwithdenzel on YouTube, Instagram, and Facebook.',
      'Denzel shares updates and tech tips on his social media. Search for growwithdenzel.',
      'You’ll find him on YouTube as growwithdenzel. great videos, by the way!',
    ],
  },
  {
    name: 'logout',
    keywords: ['logout', 'log out', 'sign out', 'exit'],
    answers: [
      'To log out, click the button next to the theme toggle at the top right.',
      'You’ll find the logout button in the top right corner of the screen.',
      'Logging out is simple. Just hit the logout icon near the theme switch.',
      'To sign out of your account, use the top-right corner menu.',
      'Want to leave for now? Tap the logout button in the top corner and come back anytime!',
    ],
  },
  {
    name: 'theme button',
    keywords: ['theme', 'theme button', 'change theme', 'dark mode'],
    answers: [
      'You can switch between light and dark mode using the theme button in the top right.',
      'The theme toggle is located next to the logout button on the navigation bar.',
      'To change your theme, use the button at the top-right corner.',
      'Light or dark? You decide. toggle the theme up top.',
      'Want a new vibe? Click the theme button near the logout and switch it up!',
    ],
  },
  {
    name: 'website link',
    keywords: ['website', 'link', 'ventrai website', 'url', 'address'],
    answers: [
      'You can visit Ventrai at https://ventrai.pages.dev.',
      'The main website link is https://ventrai.pages.dev.',
      'To access Ventrai, go to https://ventrai.pages.dev in your browser.',
      'Ventrai lives online at https://ventrai.pages.dev.',
      'Here’s your shortcut: https://ventrai.pages.dev 🎉',
    ],
  },
  {
    name: 'pricing',
    keywords: ['pricing', 'plans', 'free', 'paid', 'subscription', 'upgrade', 'credit card'],
    answers: [
      'Ventrai is completely free to use for now.',
      'All current features are free. Paid upgrades may come later.',
      'You don’t need a credit card to use Ventrai’s free plan.',
      'Ventrai’s core features are free. If paid plans launch, they’ll be optional.',
      'No cost, no catch. Ventrai is free to get started!',
    ],
  },
  {
    name: 'account page',
    keywords: ['account', 'settings', 'availability', 'connections', 'password', 'delete account'],
    answers: [
      'Your account tab lets you manage profile, availability, and more.',
      'Go to the Account page to adjust settings, availability, and view connections.',
      'You can change your password or delete your account under Settings in the Account section.',
      'The Account page has your personal details, availability, and connection preferences.',
      'Everything about your profile lives in the Account tab. easy to find!',
    ],
  },
  {
    name: 'profile page',
    keywords: ['profile', 'profiles', 'username', 'profile picture'],
    answers: [
      'To edit your profile picture and username, go to the Profile section under Account.',
      'The Profile page is in the Account tab, second option in the list.',
      'You can manage your username and profile image from the Profile section.',
      'Update your profile picture or name in the Profile tab under your Account.',
      'Want to add a new pic or name? Head to your Profile tab. it’s just a click away!',
    ],
  },
  {
    name: 'mentors page',
    keywords: ['mentors page', 'all mentors', 'mentor list', 'mentor view', 'mentees', 'find a mentor'],
    answers: [
      'Mentees can browse available mentors on the All Mentors page.',
      'The Mentors page is where you can discover and connect with mentors.',
      'Mentors may not see the All Mentors page depending on their role.',
      'Use the Mentors page to send a mentorship request to someone who fits your goals.',
      'Looking for guidance? Find mentors on the Mentors page. it’s made for you.',
      'You can find a mentor in the Mentors Page in the Navigation Bar.'
    ],
  },
  {
    name: 'connections page',
    keywords: ['connections', 'accepted', 'rejected', 'pending', 'requests', 'accept', 'reject'],
    answers: [
      'Your Connections page shows requests you’ve sent and received.',
      'Mentors can view and manage incoming mentee requests from this page.',
      'The Connections tab helps track who accepted, rejected, or is still pending.',
      'Go to Connections to handle requests and stay organized.',
      'All your mentorship requests? Yep, they’re right in the Connections tab!',
    ],
  },
  {
    name: 'chat page',
    keywords: ['chat', 'messages', 'image', 'filter', 'emoji'],
    answers: [
      'The Chat page lets mentors and mentees exchange messages and images.',
      'You can send one image per message in Chat, with filters and description prompts.',
      'Chat sessions are located next to the Account tab.',
      'Use the Chat page to message your connections and share info or files.',
      'Need to send a quick message or emoji? Head to Chat. it’s all there.',
    ],
  },
  {
    name: 'notes',
    keywords: ['notes', 'private notes'],
    answers: [
      'The Notes tab lets you keep personal notes for your own use.',
      'Private notes are only visible to you and stored securely.',
      'You can take notes during sessions using the Notes page.',
      'The Notes section is right next to Chat and is just for you.',
      'Jot it down! Your Notes tab is like your personal notepad.',
    ],
  },
  {
    name: 'github',
    keywords: ['github', 'footer', 'discussions', 'questions', 'suggestions', 'features'],
    answers: [
      'To suggest features or ask questions, visit the GitHub Discussions via the footer link.',
      'The GitHub logo in the footer leads to Ventrai’s community discussion page.',
      'GitHub Discussions is where you can leave feedback and ideas.',
      'Have thoughts or requests? Use the GitHub footer link to post them.',
      'Want to contribute ideas? GitHub’s in the footer. click it and say hello!',
    ],
  },
  {
    name: 'mentor search',
    keywords: ['search mentor', 'mentors', 'find mentor', 'request mentor'],
    answers: [
      'Use the Mentors page to search and request a mentor.',
      'Mentees can browse by skills and find the right mentor to request.',
      'Searching for a mentor? The Mentors tab is where it happens.',
      'You can request a mentorship by selecting a mentor from the list.',
      'Looking for someone awesome to guide you? Try the Mentors tab!',
    ],
  },
  {
    name: 'roles',
    keywords: ['mentor role', 'mentee role', 'roles', 'user roles', 'permissions'],
    answers: [
      'There are two user roles in Ventrai: mentor and mentee.',
      'Mentees send requests; mentors can accept or reject them.',
      'After a request is accepted, both roles can message or call each other.',
      'Roles help determine access and interactions within the platform.',
      'Whether you’re here to learn or lead, your role defines your path.',
    ],
  },
  {
    name: 'video call',
    keywords: ['video call', '1 on 1 call', 'start call', 'video session', 'chat call'],
    answers: [
      'Video calls can be started from any chat session after a connection is made.',
      'Chats include a button to start one-on-one video calls.',
      'Mentors and mentees can call each other directly from the chat window.',
      'Once you’re connected, a video call option appears in your chat.',
      'Want to jump on a quick call? Head to Chat and click the camera!',
    ],
  },
  {
    name: 'availability page',
    keywords: ['availability', 'time', 'schedule'],
    answers: [
      'You can set your available meeting times on the Availability page under the Account tab.',
      'Availability settings are found in the Account section, near the bottom of the tab list.',
      'To update your schedule, go to Availability in your Account tab.',
      'Your availability helps mentors or mentees know when you’re free. set it up under Account.',
      'Got some free hours? Add them to your Availability page so others can see when to meet!',
    ],
  },
  {
    name: 'good mentor advice',
    keywords: ['good mentor', 'best mentor', 'quality mentor', 'find good mentor', 'mentor advice', 'mentor tips', 'choose mentor', 'mentor criteria', 'mentor evaluation'],
    answers: [
      'To find a good mentor, look for someone with relevant experience in your field, good communication skills, and genuine interest in helping others grow. Check their profile for expertise areas and availability.',
      'A great mentor should have: 1) Deep knowledge in their field, 2) Strong communication skills, 3) Patience and empathy, 4) Consistent availability, 5) Clear goals for the mentorship. Review their profile and past connections!',
      'When choosing a mentor on Ventrai, consider their expertise alignment with your goals, their response time, and reviews from previous mentees. Start with a clear request about what you want to learn.',
      'Look for mentors who: Have proven experience in your area of interest, offer specific skills you want to develop, have good availability matching your schedule, and show enthusiasm for teaching. Read their profiles carefully!',
      'The best mentors combine expertise with teaching ability. On Ventrai, check their specialization, availability patterns, and consider sending a specific request about your learning goals.',
      'Quality mentors demonstrate: Deep subject knowledge, structured approach to teaching, regular availability, and personalized guidance. Use Ventrai’s search to filter by expertise and read their descriptions.',
      'To evaluate potential mentors: Review their background and expertise, check their availability matches your schedule, look for teaching experience, and start with a well-defined mentorship request.',
      'Good mentor indicators: Relevant professional experience, clear communication style, consistent availability, specific areas of expertise, and positive feedback from other mentees on the platform.'
    ],
  },
  {
    name: 'mentor relationship tips',
    keywords: ['mentor relationship', 'mentor success', 'mentor meeting', 'mentor communication', 'mentor expectations', 'mentor goals'],
    answers: [
      'For successful mentorship: Set clear goals upfront, prepare questions before meetings, be open to feedback, practice active listening, and follow through on action items discussed.',
      'Build a strong mentor relationship by: Being punctual and prepared, respecting their time, implementing their advice, sharing progress updates, and showing appreciation for their guidance.',
      'Maximize mentor value: Come to meetings with specific questions, take notes during sessions, apply what you learn, report back on results, and maintain consistent communication.',
      'Effective mentorship requires: Clear communication of your goals, regular meeting schedules, honest feedback, implementation of advice, and celebration of progress together.',
      'Make mentorship work: Define success criteria early, be coachable and receptive, do homework between sessions, track your progress, and adjust goals as needed with your mentor.'
    ],
  },
];

function findCategory(text) {
  const lower = text.toLowerCase()
  for (const category of categories) {
    for (const keyword of category.keywords) {
      if (lower.includes(keyword)) return category
    }
  }
  return null
}

const tones = {
  friendly: 'friendly and helpful',
  professional: 'concise, formal, and informative',
  casual: 'relaxed, fun, and conversational',
  creative: 'creative and engaging',
  technical: 'detailed and technical'
}

const aiBehaviors = {
  strict: 'Only answer questions directly related to Ventrai. Politely decline unrelated topics.',
  flexible: 'Primarily focus on Ventrai but can briefly acknowledge related topics like mentorship, education, and technology.',
  adaptive: 'Try to find connections to Ventrai even in loosely related questions. Be helpful while staying on topic.'
}

const fallbackResponses = {
  strict: [
    "I specialize in helping with Ventrai-related questions. Could you ask something about the platform?",
    "My expertise is focused on Ventrai. What would you like to know about the mentorship platform?",
    "I'm here to help with Ventrai questions. What aspect of the platform interests you?"
  ],
  flexible: [
    "While I focus on Ventrai, I can help with mentorship-related topics. How does that relate to your learning goals?",
    "That's interesting! While Ventrai is my specialty, I can discuss mentorship concepts. Are you looking to connect with mentors?",
    "I can help with mentorship topics! Ventrai connects mentors and mentees - is that what you're exploring?"
  ],
  adaptive: [
    "Let me think about how that relates to Ventrai's mission of connecting learners and mentors...",
    "That's an interesting angle! Ventrai aims to make mentorship accessible - how does your question connect to that?",
    "I can explore that idea in the context of Ventrai's goal of facilitating meaningful mentorship connections."
  ]
}

const suggestions = [
  'What is Ventrai?',
  'Who made Ventrai?',
  'How do I find a mentor?',
  'Where do I manage my account?',
  'Can I video call a mentor?',
]

export default function ChatWidget({ information }) {
  const [generator, setGenerator] = useState(null)
  const [history, setHistory] = useState([])
  const [input, setInput] = useState('')
  const [minimized, setMinimized] = useState(true)
  const [tone, setTone] = useState('friendly')
  const [behavior, setBehavior] = useState('flexible')
  const [creativity, setCreativity] = useState(0.7)
  const [maxTokens, setMaxTokens] = useState(100)
  const [recentTopics, setRecentTopics] = useState(new Set())
  const [responseVariations, setResponseVariations] = useState({})

  const keywords = categories.flatMap(c => c.keywords)
  const greetingKeywords = ['hi', 'hello', 'hey', 'hi there', 'hi!', 'hello there!', 'hey there!', 'hey!', 'hello!']
  const fascinatedKeywords = ['really', 'damn', 'wow', 'amazing', 'incredible', 'awesome', 'cool', 'nice', 'whoa', 'omg', 'oh my god', 'holy cow', 'unbelievable', 'fantastic', 'great', 'perfect']
  const ventraiCoreKeywords = ['ventrai', 'mentor', 'mentee', 'mentorship', 'learning', 'education', 'platform', 'connect', 'guidance', 'teaching', 'knowledge', 'denzel', 'babajide']

  useEffect(() => {
    async function loadModel() {
      try {
        const pipe = await pipeline('text2text-generation', 'Xenova/t5-base')
        setGenerator(() => pipe)
      } catch (error) {
        console.error('Error loading model:', error)
      }
    }
    loadModel()
  }, [])

  const correctTypos = (text) => {
    const words = text.toLowerCase().split(/\s+/)
    const allKeywords = [...keywords, ...ventraiCoreKeywords]
    
    return words.map(word => {
      // Try exact match first
      if (allKeywords.includes(word)) return word
      
      // Try fuzzy matching with more lenient threshold
      const fuzzyResult = fuzzysort.go(word, allKeywords)
      if (fuzzyResult.length > 0 && fuzzyResult[0].score > -30) {
        return fuzzyResult[0].target
      }
      
      // Try partial matching for longer words
      if (word.length > 3) {
        for (const keyword of allKeywords) {
          if (keyword.includes(word) || word.includes(keyword)) {
            return keyword
          }
        }
      }
      
      return word
    }).join(' ')
  }

  const isVentraiRelated = (text) => {
    const words = text.toLowerCase().split(/\s+/)
    const allKeywords = [...keywords, ...ventraiCoreKeywords]
    
    // Check for direct Ventrai keywords with fuzzy matching
    const directMatch = words.some(word => {
      const result = fuzzysort.go(word, allKeywords)
      return result.length > 0 && result[0].score > -30
    })
    if (directMatch) return true
    
    // Check for related concepts based on behavior setting
    if (behavior === 'flexible' || behavior === 'adaptive') {
      const relatedMatch = words.some(word => ventraiCoreKeywords.includes(word))
      if (relatedMatch) return true
    }
    
    // Check partial matches for longer words
    if (behavior === 'adaptive') {
      const partialMatch = words.some(word => {
        if (word.length > 3) {
          return allKeywords.some(keyword => 
            keyword.includes(word) || word.includes(keyword)
          )
        }
        return false
      })
      if (partialMatch) return true
    }
    
    return false
  }

  const getFallbackResponse = () => {
    const responses = fallbackResponses[behavior] || fallbackResponses.flexible
    return responses[Math.floor(Math.random() * responses.length)]
  }

  const generateContextualResponse = (userInput) => {
    const inputLower = userInput.toLowerCase()
    const contextMap = {
      'learning': 'Ventrai facilitates learning by connecting you with experienced mentors who can guide your journey.',
      'career': 'Through Ventrai, you can find mentors who can help with career guidance and professional development.',
      'skills': 'Ventrai helps you connect with mentors who can teach specific skills and share their expertise.',
      'education': 'Ventrai is an educational platform that makes mentorship accessible to everyone.',
      'help': "I'm here to help you understand Ventrai better! What specific aspect would you like to explore?",
      'how': 'Ventrai works by connecting mentors and mentees in a simple, accessible way.',
      'why': 'Ventrai was created to make quality mentorship accessible to everyone, regardless of background.',
      'find': 'You can find mentors and mentees on Ventrai! The platform makes it easy to connect with the right people.',
      'look': 'Looking for something specific? Ventrai helps you discover mentors who match your learning goals.',
      'search': 'You can search for mentors on Ventrai based on their expertise and availability.',
      'want': 'Want to learn something new? Ventrai connects you with mentors who can teach you!'
    }
    
    // Check for exact matches first
    for (const [key, response] of Object.entries(contextMap)) {
      if (inputLower.includes(key)) {
        return response
      }
    }
    
    // Check for fuzzy matches
    const correctedInput = correctTypos(userInput)
    const correctedLower = correctedInput.toLowerCase()
    for (const [key, response] of Object.entries(contextMap)) {
      if (correctedLower.includes(key)) {
        return response
      }
    }
    
    return getFallbackResponse()
  }

  const isFascinatedExpression = (text) => {
    const normalized = text.trim().toLowerCase()
    return fascinatedKeywords.some(keyword => normalized.includes(keyword))
  }

  const getFascinatedResponse = () => {
    const responses = [
      "Right? It's pretty amazing how Ventrai connects people!",
      "I know! The platform really makes mentorship accessible.",
      "Exactly! That's what makes Ventrai so special.",
      "Pretty cool, right? Denzel really created something meaningful.",
      "Isn't it great? Ventrai makes learning so much more accessible!",
      "Totally! The way Ventrai brings mentors and mentees together is fantastic.",
      "I agree! It's amazing what Ventrai enables for people.",
      "For real! Ventrai is changing how people access mentorship."
    ]
    return responses[Math.floor(Math.random() * responses.length)]
  }

  const isGreeting = (text) => {
    const normalized = text.trim().toLowerCase()
    return greetingKeywords.includes(normalized)
  }

  const updateTopicMemory = (categoryName, answer) => {
    // Update recent topics (keep last 10)
    setRecentTopics(prev => {
      const newTopics = new Set(prev)
      newTopics.add(categoryName)
      // Keep only last 10 topics
      if (newTopics.size > 10) {
        const topicsArray = Array.from(newTopics)
        return new Set(topicsArray.slice(-10))
      }
      return newTopics
    })

    // Update response variations for this category
    setResponseVariations(prev => {
      const variations = prev[categoryName] || []
      const newVariations = [...variations, answer]
      // Keep only last 5 responses for this category
      return {
        ...prev,
        [categoryName]: newVariations.slice(-5)
      }
    })
  }

  const getNonRepetitiveAnswer = (category) => {
    const recentAnswers = responseVariations[category.name] || []
    const availableAnswers = category.answers.filter(answer => !recentAnswers.includes(answer))
    
    if (availableAnswers.length > 0) {
      return availableAnswers[Math.floor(Math.random() * availableAnswers.length)]
    }
    
    // If all answers were used recently, return the oldest one
    return recentAnswers[0] || category.answers[0]
  }

  const hasRecentSimilarTopic = (categoryName) => {
    return recentTopics.has(categoryName)
  }

  const handleSend = async () => {
    if (!input.trim() || !generator) return
    const cleaned = input.trim().toLowerCase()

    if (isGreeting(cleaned)) {
      setHistory([...history, { q: input, a: "Hey there, I'm BotTrai! What do you need help with?" }])
      setInput('')
      return
    }

    if (isFascinatedExpression(cleaned)) {
      const fascinatedResponse = getFascinatedResponse()
      setHistory([...history, { q: input, a: fascinatedResponse }])
      setInput('')
      return
    }

    const category = findCategory(cleaned)
    if (category) {
      const answer = getNonRepetitiveAnswer(category)
      updateTopicMemory(category.name, answer)
      
      // If this topic was discussed recently, add a contextual note
      let finalAnswer = answer
      if (hasRecentSimilarTopic(category.name) && recentTopics.size > 1) {
        const contextualAdditions = [
          " (Building on our earlier discussion...)",
          " (As we were talking about before...)",
          " (Following up on this topic...)"
        ]
        const addition = contextualAdditions[Math.floor(Math.random() * contextualAdditions.length)]
        finalAnswer = answer + addition
      }
      
      setHistory([...history, { q: input, a: finalAnswer }])
      setInput('')
      return
    }

    if (!isVentraiRelated(cleaned)) {
      const contextualResponse = generateContextualResponse(input)
      setHistory([...history, { q: input, a: contextualResponse }])
      setInput('')
      return
    }

    const corrected = correctTypos(input)
    const lastTurns = history.slice(-4).map(({ q, a }) => `Q: ${q}\nA: ${a}`).join('\n')
    const behaviorPrompt = aiBehaviors[behavior] || aiBehaviors.flexible
    const prompt = `You are a ${tones[tone]} assistant for Ventrai, a mentorship platform created by Denzel Babajide. ${behaviorPrompt} Answer based only on this context:\n\n${information.trim()}\n\n${lastTurns}\nQ: ${corrected}\nA:`

    try {
      const result = await generator(prompt, { max_new_tokens: maxTokens, temperature: creativity })
      const response = result[0].generated_text.trim().split(/\s+/).slice(0, 50).join(' ')
      setHistory([...history, { q: input, a: response }])
      setInput('')
    } catch (error) {
      console.error('Error generating response:', error)
    }
  }

  if (minimized) {
    return (
      <button
        onClick={() => setMinimized(false)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          padding: '12px 16px',
          fontSize: '14px',
          background: '#007bff',
          color: 'white',
          borderRadius: '24px',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          zIndex: 1000
        }}
      >
        <i className="bi bi-robot" style={{ color: 'gold' }}></i>
        Chat with BotTrai
        <small style={{
          border: '2px solid green',
          borderRadius: '12px',
          color: 'green',
          backgroundColor: '#f3f3f3',
          padding: '2px 6px',
          fontSize: '10px'
        }}>beta</small>
      </button>
    )
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      width: '320px',
      background: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontFamily: 'Arial, sans-serif',
      zIndex: 1000
    }}>
      <div style={{
        background: '#007bff',
        color: 'white',
        padding: '12px',
        fontWeight: 'bold',
        textAlign: 'center',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px'
      }}>
        <i className="bi bi-robot" style={{ color: 'gold' }}></i>
        Chat with BotTrai
        <small style={{
          border: '2px solid green',
          borderRadius: '12px',
          color: 'green',
          backgroundColor: '#f3f3f3',
          padding: '2px 6px',
          fontSize: '10px'
        }}>beta</small>
        <button
          onClick={() => setMinimized(true)}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '18px',
            cursor: 'pointer'
          }}
        >−</button>
      </div>

      <div style={{ padding: '8px 10px', fontSize: '13px', borderBottom: '1px solid #ccc' }}>
        <label style={{ marginRight: '8px', fontWeight: 'bold' }}>Tone:</label>
        <select
          value={tone}
          onChange={e => setTone(e.target.value)}
          style={{
            padding: '4px 8px',
            fontSize: '13px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            marginRight: '10px'
          }}
        >
          <option value="friendly">Friendly</option>
          <option value="professional">Professional</option>
          <option value="casual">Casual</option>
          <option value="creative">Creative</option>
          <option value="technical">Technical</option>
        </select>
        
        <label style={{ marginRight: '8px', fontWeight: 'bold' }}>Behavior:</label>
        <select
          value={behavior}
          onChange={e => setBehavior(e.target.value)}
          style={{
            padding: '4px 8px',
            fontSize: '13px',
            borderRadius: '6px',
            border: '1px solid #ccc'
          }}
        >
          <option value="strict">Strict</option>
          <option value="flexible">Flexible</option>
          <option value="adaptive">Adaptive</option>
        </select>
      </div>
      
      <div style={{ padding: '8px 10px', fontSize: '13px', borderBottom: '1px solid #ccc' }}>
        <label style={{ marginRight: '8px', fontWeight: 'bold' }}>Creativity:</label>
        <input
          type="range"
          min="0.1"
          max="1.5"
          step="0.1"
          value={creativity}
          onChange={e => setCreativity(parseFloat(e.target.value))}
          style={{ marginRight: '10px', width: '80px' }}
        />
        <span style={{ fontSize: '12px', color: '#666' }}>{creativity.toFixed(1)}</span>
        
        <label style={{ marginRight: '8px', fontWeight: 'bold', marginLeft: '10px' }}>Max Tokens:</label>
        <input
          type="number"
          min="50"
          max="200"
          value={maxTokens}
          onChange={e => setMaxTokens(parseInt(e.target.value))}
          style={{
            width: '60px',
            padding: '2px 4px',
            fontSize: '13px',
            borderRadius: '4px',
            border: '1px solid #ccc'
          }}
        />
      </div>

      <div style={{
        padding: '8px 10px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
        borderBottom: '1px solid #ddd',
        backgroundColor: '#f9f9f9'
      }}>
        {suggestions.map((text, i) => (
          <button
            key={i}
            onClick={() => {
              setInput(text)
              handleSend()
            }}
            style={{
              background: '#e0e0e0',
              border: 'none',
              borderRadius: '16px',
              padding: '4px 10px',
              fontSize: '12px',
              cursor: 'pointer'
            }}
          >
            {text}
          </button>
        ))}
      </div>

      <div style={{
        flex: 1,
        padding: '10px',
        maxHeight: '260px',
        overflowY: 'auto',
        fontSize: '14px'
      }}>
        {history.map((entry, i) => (
          <div key={i} style={{ marginBottom: '10px' }}>
            <div style={{
              backgroundColor: 'rgb(0, 123, 255)',
              borderRadius: '8px',
              padding: '5px',
              color: 'white',
              marginBottom: '5px'
            }}>
              <strong>You:</strong> {entry.q}
            </div>
            <div style={{
              backgroundColor: '#d2d2d2',
              borderRadius: '8px',
              padding: '5px',
              marginBottom: '5px',
              color: '#333'
            }}>
              <strong><i className="bi bi-robot" style={{ color: 'gold' }}></i> BotTrai:</strong> {entry.a}
            </div>
          </div>
        ))}
      </div>

      <div style={{
        display: 'flex',
        borderTop: '1px solid #ddd'
      }}>
        <input
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSend()}
          placeholder="Ask about Ventrai..."
          style={{
            flex: 1,
            border: 'none',
            padding: '10px',
            fontSize: '14px',
            outline: 'none'
          }}
        />
        <button
          onClick={handleSend}
          style={{
            border: 'none',
            background: '#007bff',
            color: 'white',
            padding: '0 16px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '14px'
          }}
        >Send</button>
      </div>
    </div>
  )
}
